import React from "react";
import styled from "styled-components";
import {device} from "../../assets/styles/media";

const InfoBtn = styled.div`
    margin: ${(props)=> props.mt ? `${props.mt}px 0 10px 0` : '100px 0 10px 0'};
    text-align: center;

    ${device.tablet} {
        margin: 15px 0 10px 0;
    }
    
    ${device.mobile} {
        margin: 15px 0 10px 0;
    }
`;
const BtnMore = styled.button`
    display: inline-block;
    padding: 13px 42px;
    border-radius: 5px;
    background: ${(props) => props.color ? props.color : "#ef9f14"};
    color: #fff;
    border: ${(props) => props.border ? props.border : "1px solid #fff"};
    font-size: 15px;
    font-weight: 600;
    text-align: center;
    transition: 0.5s ease;

    &:hover {
        background-color: ${({hover})=> hover? "#fff" : "default"};
        color: ${({hover})=> hover? "#ef9f14" : "default"};
        border : ${({hover})=> hover? "1px solid #ef9f14" : "default"} ;
    }

    ${device.tablet} {
        margin-top: 0;
        padding: 10px 30px;
        font-size: 15px;
        font-weight: bold;
    }
    ${device.mobile} {
        //padding: 7px 20px;
        padding: 10px 25px;
        font-size: 13px;
        font-weight: 600;
    }
`;

const Btn = ({text,onClick, color,border, hover,mt}) => {
    return (
        <InfoBtn mt={mt}>
            <BtnMore
                type="button"
                color={color}
                border={border}
                onClick={onClick}
                hover={hover}

            >{text}</BtnMore>
        </InfoBtn>
    );
};

export default Btn;
